import React, { useEffect, useContext, useState } from "react";
import styled from "styled-components";

import { useLocation, useNavigate } from "react-router-dom";

import style from "../../style/AccountAddBody.module.scss";
import { AuthContext } from "../../contexts/AuthContext";
import { TagPicker } from "rsuite";
import { useForm } from "react-hook-form";
import apiClient from "../../libraries/ApiClient";
import { useQuery } from "react-query";
import { styled as styles, alpha } from "@mui/material/styles";
import {
  TextField,
  Radio,
  RadioGroup,
  FormGroup,
  Checkbox,
  FormControlLabel,
  FormControl,
  MenuItem,
  FormLabel,
  Button,
  Autocomplete,
} from "@mui/material";
import { tr } from "date-fns/locale";
import { LoginContext } from "../../contexts/LoginContext";

const CssTextField = styles((props) => <TextField {...props} fullWidth />)(
  ({ theme }) => ({
    "& .MuiFilledInput-root": {
      border: "1px solid #e2e2e1",
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none",
      },
      "&:before": {
        border: "none",
      },
      "&:after": {
        border: "none",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
      },
      "&.Mui-error": {
        borderColor: "#D92920",
        color: "#EB4D3D",
      },
    },
  })
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  h1 {
    line-height: 20px;
  }
  .search {
    width: 100%;
    .searchTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      position: relative;
      .left {
        display: flex;
        .otherCondition {
          width: 120px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          border: 1px solid #f2f2f2;
          border-radius: 5px;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .right {
        .searchBtn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 120px;
        }
      }
    }
    .searchBottom {
      border: 1px solid #f2f2f2;
      background-color: #f2f2f2;
      width: 100%;
      padding: 8px;
      border-radius: 5px;
      display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
      position: absolute;
      z-index: 1;
      flex-direction: column;
      .top {
        display: flex;
        justify-content: space-between;
        .basicInformation {
          width: 49%;
        }
        .caseStatus {
          width: 49%;
        }
      }
    }
  }
  .pagination {
    height: 100px;
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    position: absolute;
    bottom: 0px;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

function AccountAddBody({ Mode, rowId, setSendAccountData }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  const { myAuth } = useContext(AuthContext);
  const isLoginAtAdmin = myAuth.IsAdmin;
  const isLoginAtPermission = myAuth.AccountPermission;

  const IdentitiesData = [
    { label: "神內醫師", value: "neurology" },
    { label: "取栓醫師", value: "tbc_doctor" },
    { label: "微創放射師", value: "radiation_therapy" },
    { label: "微創護理師", value: "nurse" },
    { label: "個管師", value: "case_management" },
    { label: "管理者", value: "admin" },
    { label: "麻醉科醫師", value: "anes_doctor" },
    { label: "麻醉科護理師", value: "anes_nurse" },
    { label: "急診專科護理師", value: "er_nurse" },
    { label: "ICU護理師", value: "icu_nurse" },
  ].map((item) => ({ label: item.label, value: item.value }));

  //所屬醫院
  const [OrgCode, setOrgCode] = useState("");
  const [OrgName, setOrgName] = useState("");
  const [OrgData, setOrgData] = useState({});
  //職務類型
  const [Identities, setIdentities] = useState([]);
  //員工編號
  const [StaffCode, setStaffCode] = useState("");
  //管理者姓名
  const [adminName, setAdminName] = useState("");
  //帳號信箱
  const [email, setEmail] = useState("");
  //登入密碼
  const [password, setPassword] = useState("");
  //帳號手機
  const [AccountPhone, setAccountPhone] = useState("");
  //分機號碼
  const [ExtensionNumber, setExtensionNumber] = useState("");
  //簡碼號碼
  const [ShortNumber, setShortNumber] = useState("");
  //手機號碼
  const [PhoneNumber, setPhoneNumber] = useState("");
  //帳號管理權限設定
  const [IsAdmin, setIsAdmin] = useState(1);
  const [AccountPermission, setAccountPermission] = useState(4);
  //啟用/停用 帳號
  const [Status, setStatus] = useState(1);
  //有排班需求
  const [IsShift, setIsShift] = useState(true);
  //可發送簡訊
  const [CanSNS, setCanSNS] = useState(true);
  //信箱及員編可否編輯
  const [IsEdit, setIsEdit] = useState(false);

  //建立時間
  const [CreateDateTime, setCreateDateTime] = useState("");
  //修改人
  const [ModifyUser, setModifyUser] = useState("");
  //修改時間
  const [ModifyDateTime, setModifyDateTime] = useState("");
  //Line綁定
  const [LineBinding, setLineBinding] = useState("");

  //錯誤判斷
  const [staffCodeError, setStaffCodeError] = useState(false);
  const [adminNameError, setAdminNameError] = useState(false);
  const [hasMailError, setHasMailError] = useState(false);
  const [hasPasswordError, setHasPasswordError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  //是否可改排班需求
  const [IsShiftDisabled, setIsShiftDisabled] = useState(false);
  //是否可改發送簡訊
  const [CanSNSDisabled, setCanSNSDisabled] = useState(false);

  //錯誤判斷
  const [hasPhoneNumberError, setHasPhoneNumberError] = useState(false);
  const [hasAccountPhoneError, setHasAccountPhoneError] = useState(false);
  const [CanAddAcountPhone, setCanAddAcountPhone] = useState(false);
  const [CanAddStaffCode, setCanAddStaffCode] = useState(false);

  const [myself, setMySelf] = useState(false);

  const emailRule =
    /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
  const passwordRule = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
  const phoneNumberRule = /^09\d{8}$|^$/;

  const validateMailValue = (value) => emailRule.test(value);
  const validatePasswordValue = (value) => passwordRule.test(value);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
  }, []);

  //查詢帳號資料
  const getAccountDetail = async ({ queryKey }) => {
    const data = {
      Data: {
        RowId: rowId,
      },
    };

    const res = await apiClient.postAes("api/account/Detail/Security", data);
    if (res?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
      return null;
    }

    return res?.data;
  };

  useEffect(() => {
    if (
      AccountId == rowId &&
      // (isLoginAtAdmin == false || isLoginAtAdmin == undefined)
      (isLoginAtPermission == 3 || isLoginAtPermission == 4)
    ) {
      setMySelf(true);
    } else {
      setMySelf(false);
    }
    console.log(myself);
  }, [AccountId, rowId, isLoginAtAdmin]);

  //查詢醫院資料
  const getHospitalData = async ({ queryKey }) => {
    const data = {
      Data: {},
    };

    const res = await apiClient.postAes("api/referral/GetOrg/Security", data);
    return res?.data?.Data?.Orgs;
  };

  const { data: hospitalData } = useQuery(
    ["getHospitalData", token],
    getHospitalData,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  const { getValues, control, setValue } = useForm({
    defaultValues: {
      Identities: [],
    },
  });

  const { data, refetch, isLoading } = useQuery(
    ["getAccountDetail", rowId, token],
    getAccountDetail,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    if (Mode === "Edit") {
      console.log(data?.Data);
      setOrgCode(`${data?.Data?.OrgCode}`);
      // setOrgName(data?.Data?.OrgName);
      let tempData = { Code: data?.Data?.OrgCode, Name: data?.Data?.OrgName };
      console.log(tempData);
      setOrgData(tempData);

      setIdentities(data?.Data?.Identities);
      setStaffCode(data?.Data?.StaffCode);
      setCanAddStaffCode(
        data?.Data.StaffCode == "" || data?.Data.StaffCode == undefined
          ? true
          : false
      );
      setAdminName(data?.Data?.Name);
      setEmail(data?.Data?.Email);
      setPassword(data?.Data?.password);
      setAccountPhone(data?.Data.AccountPhone);
      setCanAddAcountPhone(
        data?.Data.AccountPhone == "" || data?.Data.AccountPhone == undefined
          ? true
          : false
      );
      setExtensionNumber(data?.Data?.ExtensionNumber);
      setShortNumber(data?.Data?.ShortNumber);
      setPhoneNumber(data?.Data?.PhoneNumber);
      setIsAdmin(`${data?.Data?.IsAdmin}` === "true" ? 1 : 4);
      setAccountPermission(+data?.Data?.AccountPermission);
      setStatus(+data?.Data?.Status);
      setIsShift(`${data?.Data?.IsShift}` === "true" ? true : false);
      setCanSNS(`${data?.Data?.CanSNS}` === "true" ? true : false);
      setIsEdit(data?.Data?.IsEdit);
      setCreateDateTime(data?.Data?.CreateDateTime);
      setModifyUser(data?.Data?.ModifyUser);
      setModifyDateTime(data?.Data?.ModifyDateTime);
      setLineBinding(data?.Data?.LineBinding);
    }
  }, [data]);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailBlur = (e) => {
    if (e.target.value === "") {
      setHasMailError(true);
    } else {
      const result = emailRule.test(e.target.value);
      setHasMailError(!result);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handlePasswordBlur = (e) => {
    if (e.target.value === "") {
      setHasPasswordError(true);
    } else {
      const result = passwordRule.test(e.target.value);
      setHasPasswordError(!result);
    }
  };

  const handleExtensionNumberChange = (e) => {
    setExtensionNumber(e.target.value);
  };

  const handleShortNumberChange = (e) => {
    setShortNumber(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };
  const handlePhoneNumberBlur = (e) => {
    const result = phoneNumberRule.test(e.target.value);
    setHasPhoneNumberError(!result);
  };

  const handleAccountPhoneChange = (e) => {
    setAccountPhone(e.target.value);
  };
  const handleAccountPhoneBlur = (e) => {
    if (e.target.value === "") {
      setHasAccountPhoneError(true);
    } else {
      const result = phoneNumberRule.test(e.target.value);
      setHasAccountPhoneError(!result);
    }
  };

  const handleAdminNameChange = (e) => {
    setAdminName(e.target.value);
  };

  const handleAdminNameBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setAdminNameError(true);
    } else {
      setAdminNameError(false);
    }
  };

  const handleStaffCodeChange = (e) => {
    setStaffCode(e.target.value);
  };

  const handleStaffCodeBlur = (e) => {
    const input = e.target.value;
    if (input === "") {
      setStaffCodeError(true);
    } else {
      setStaffCodeError(false);
    }
  };

  const handleIsShiftChange = (e) => {
    setIsShift(e.target.checked);
  };

  const handleCanSNSChange = (e) => {
    setCanSNS(e.target.checked);
  };

  const handleIsAdminChange = (e) => {
    setIsAdmin(e.target.value);
  };
  const handleAccountPermissionChange = (e) => {
    setAccountPermission(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleHospitalChange = (e) => {
    const input = e.target.innerText;
    // setOrgName(e);
    // console.log(hospitalData.find((h) => h.Name == e).Code, "OrgCode");
    // console.log(e.target.value);
    // console.log(hospitalData);
    if (e === "") {
    } else {
      let result = hospitalData.find((h) => h.Name === input);
      setOrgCode(result.Code);
      console.log(result);
      // setOrgCode(input);
      setOrgData(result);
    }
  };

  const handleIdentitiesChange = (e) => {
    setIsShift(true);
    setIdentities(e);
  };

  useEffect(() => {
    if (Mode === "Add" && OrgCode === "1532100049") {
      if (Identities?.length > 0) {
        setIsShift(true);
        setCanSNS(false);
        setIsShiftDisabled(false);
        setCanSNSDisabled(false);
        if (
          Identities.includes("neurology") ||
          Identities.includes("tbc_doctor")
        ) {
          setIsShift(true);
          setIsShiftDisabled(true);
          setCanSNS(true);
          setCanSNSDisabled(true);
        }
      } else if (Identities?.length === 0) {
        setIsShift(true);
        setIsShiftDisabled(false);
        setCanSNS(false);
        setCanSNSDisabled(false);
      } else {
        setIsShift(false);
        setIsShiftDisabled(false);
        setCanSNS(false);
        setCanSNSDisabled(false);
      }
    } else {
      if (Identities?.length > 0) {
        setIsShiftDisabled(false);
        setCanSNSDisabled(false);
        if (
          Identities.includes("neurology") ||
          Identities.includes("tbc_doctor")
        ) {
          setIsShift(true);
          setIsShiftDisabled(true);
          setCanSNS(true);
          setCanSNSDisabled(true);
        }
        // else {
        //   setIsShift(false);
        //   setIsShiftDisabled(false);
        //   setCanSNS(false);
        //   setCanSNSDisabled(false);
        // }
      } else if (Identities?.length === 0) {
        setIsShift(true);
        setIsShiftDisabled(false);
        setCanSNS(false);
        setCanSNSDisabled(false);
      }
      // else {
      //   console.log('HERE');
      //   setIsShift(false);
      //   setIsShiftDisabled(false);
      //   setCanSNS(false);
      //   setCanSNSDisabled(false);
      // }
    }
  }, [Mode, OrgCode, Identities, IsShiftDisabled]);

  const sendAccountDataModel = {
    OrgCode: OrgCode,
    Identities: Identities,
    StaffCode: StaffCode,
    Name: adminName,
    Email: email,
    Password: password,
    IsAdmin: IsAdmin,
    Status: +Status,
    IsShift: IsShift,
    CanSNS: CanSNS,
    RowId: rowId,
    AccountPhone: AccountPhone,
    ExtensionNumber: ExtensionNumber,
    ShortNumber: ShortNumber,
    PhoneNumber: PhoneNumber,
    CreateDateTime: CreateDateTime,
    ModifyUser: ModifyUser,
    ModifyDateTime: ModifyDateTime,
    LineBinding: LineBinding,
    hasPhoneNumberError: hasPhoneNumberError,
    hasAccountPhoneError: hasAccountPhoneError,
    AccountPermission: AccountPermission,
  };

  useEffect(() => {
    setSendAccountData(sendAccountDataModel);
  }, [
    OrgCode,
    Identities,
    StaffCode,
    adminName,
    email,
    password,
    ExtensionNumber,
    ShortNumber,
    PhoneNumber,
    IsAdmin,
    Status,
    IsShift,
    CanSNS,
    IsEdit,
    ExtensionNumber,
    ShortNumber,
    PhoneNumber,
    hasPhoneNumberError,
    AccountPhone,
    hasAccountPhoneError,
    AccountPermission,
  ]);

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <div className={style.container}>
      <div className={style.top_container}>
        <div className={style.sub_container}>
          <blockquote className={style.blockquote}>
            <div className={style.title}>帳號資料</div>
          </blockquote>
        </div>
        <ul className={style.textInfo}>
          <li>新增時皆為必填；編輯時密碼非必填</li>
          <li>首次登入密碼由新增之管理帳號設定</li>
          <li>首次登入需先完成帳號信箱驗證</li>
        </ul>
        <div className={style.fist_line}>
          <div className={style.hospital_box}>
            {hospitalData ? (
              <Autocomplete
                key={Date.now}
                disablePortal
                options={hospitalData}
                sx={{ width: "100%" }}
                // value={OrgData || null}
                // onChange={handleHospitalChange}
                value={OrgData || {}}
                onChange={(_, newValue) => {
                  console.log(newValue);
                  setOrgData(newValue);
                  setOrgCode(newValue.Code);
                }}
                disableClearable
                getOptionLabel={(option) => (option && option.Name) || ""}
                renderInput={(params) => (
                  <CssTextField
                    {...params}
                    variant="filled"
                    label="請選擇所屬醫院"
                  />
                )}
              />
            ) : (
              <Autocomplete
                disablePortal
                options={[]}
                sx={{ width: "100%" }}
                // onChange={handleHospitalChange}
                disableClearable
                renderInput={(params) => (
                  <CssTextField
                    {...params}
                    variant="filled"
                    label="請選擇所屬醫院"
                  />
                )}
              />
            )}
          </div>
          <div className={style.hospital_box}>
            <TagPicker
              data={IdentitiesData}
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "#fcfcfb",
              }}
              value={Identities}
              placeholder="職務類型(可多選)"
              onChange={handleIdentitiesChange}
              searchable={false}
              disabled={myself}
            />
          </div>
          <div className={style.identity_box}>
            {Mode == "Add" || IsEdit == true || CanAddStaffCode == true ? (
              <CssTextField
                label="請輸入員工編號"
                variant="filled"
                value={StaffCode}
                error={staffCodeError}
                onBlur={handleStaffCodeBlur}
                onChange={handleStaffCodeChange}
                style={{ width: "100%" }}
              />
            ) : (
              <CssTextField
                label="請輸入員工編號"
                variant="filled"
                value={StaffCode}
                error={staffCodeError}
                onBlur={handleStaffCodeBlur}
                onChange={handleStaffCodeChange}
                style={{ width: "100%" }}
                disabled
              />
            )}
          </div>
        </div>
        <div className={style.second_line}>
          <div className={style.identity_box}>
            <CssTextField
              label="輸入管理者姓名"
              variant="filled"
              value={adminName}
              error={adminNameError}
              onBlur={handleAdminNameBlur}
              onChange={handleAdminNameChange}
              style={{ width: "100%" }}
              disabled={myself}
            />
          </div>
          <div className={style.identity_box}>
            {Mode == "Add" ||
            IsEdit == true ||
            email == "" ||
            email == undefined ? (
              <CssTextField
                label="帳號信箱"
                variant="filled"
                value={email}
                error={hasMailError}
                onBlur={handleEmailBlur}
                onChange={handleEmailChange}
                style={{ width: "100%" }}
              />
            ) : (
              <CssTextField
                label="帳號信箱"
                variant="filled"
                value={email}
                error={hasMailError}
                onBlur={handleEmailBlur}
                onChange={handleEmailChange}
                style={{ width: "100%" }}
                disabled
              />
            )}
            <div style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}>
              {hasMailError && "格式錯誤，需符合信箱格式並檢查不可有空白"}
            </div>
          </div>
          <div className={style.identity_box}>
            <CssTextField
              label="登入密碼(英數組合至少8碼)"
              variant="filled"
              value={password}
              error={hasPasswordError}
              onBlur={handlePasswordBlur}
              onChange={handlePasswordChange}
              style={{ width: "100%" }}
              disabled={myself}
            />
            <div style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}>
              {hasPasswordError &&
                "密碼請輸入英數組合至少8碼，避免特殊符號或空白"}
            </div>
          </div>
        </div>
        <div className={style.third_line}>
          <div className={style.identity_box}>
            {Mode == "Add" || IsEdit == true || CanAddAcountPhone == true ? (
              <CssTextField
                label="帳號手機"
                variant="filled"
                value={AccountPhone}
                error={hasAccountPhoneError}
                onBlur={handleAccountPhoneBlur}
                onChange={handleAccountPhoneChange}
                style={{ width: "100%" }}
                disabled={myself}
              />
            ) : (
              <CssTextField
                label="帳號手機"
                variant="filled"
                value={AccountPhone}
                error={hasAccountPhoneError}
                onBlur={handleAccountPhoneBlur}
                onChange={handleAccountPhoneChange}
                style={{ width: "100%" }}
                disabled
              />
            )}
            <div style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}>
              {hasAccountPhoneError &&
                "格式錯誤，需符合手機號碼格式並檢查不可有空白"}
            </div>
          </div>
          <div className={style.identity_box}></div>
          <div className={style.identity_box}></div>
        </div>
        <div className={style.four_line}>
          <div className={style.gender_box}>
            <FormControl fullWidth error={statusError} disabled={myself}>
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                啟用/停用 帳號
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleStatusChange}
                value={Status}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="啟用"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="停用"
                />
                <FormControlLabel
                  value={4}
                  control={<Radio size="small" />}
                  label="啟用-臨時帳號"
                />
                <FormControlLabel
                  value={5}
                  control={<Radio size="small" />}
                  label="停用-臨時帳號"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className={style.gender_box}>
            <FormControl
              fullWidth
              disabled={myself || isLoginAtPermission == 2}
            >
              <FormLabel
                style={{
                  fontSize: "10px",
                  color: "rgba(0, 0, 0, 0.6)",
                  position: "absolute",
                  top: "5px",
                  left: "8px",
                  background: "transparent",
                }}
              >
                帳號管理權限設定
              </FormLabel>
              <RadioGroup
                row
                style={{ paddingLeft: "50px", paddingTop: "12px" }}
                onChange={handleAccountPermissionChange}
                value={AccountPermission}
              >
                <FormControlLabel
                  value={1}
                  control={<Radio size="small" />}
                  label="超級管理員"
                />
                <FormControlLabel
                  value={2}
                  control={<Radio size="small" />}
                  label="一般管理員"
                />
                <FormControlLabel
                  value={3}
                  control={<Radio size="small" />}
                  label="醫學中心窗口"
                />
                <FormControlLabel
                  value={4}
                  control={<Radio size="small" />}
                  label="無帳號管理權限"
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className={style.gender_box}></div>
        </div>
        {OrgCode == "1532100049" ? (
          <div>
            <div className={style.sub_container}>
              <blockquote className={style.blockquote}>
                <div className={style.title}>值班聯絡資訊</div>
              </blockquote>
            </div>
            <ul className={style.textInfo}>
              <li>取栓醫師請勾選「可發送簡訊」並提供手機號碼</li>
              <li>
                勾選「有排班需求」才會建立於排班名單，並請至少提供1項聯絡資訊
              </li>
            </ul>
            <div className={style.six_line}>
              <div className={style.gender_box}>
                <FormGroup row>
                  <div className={style.name_checkbox}>
                    <Checkbox
                      checked={IsShift}
                      inputProps={{ "aria-label": "controlled" }}
                      onChange={handleIsShiftChange}
                      size="small"
                      disabled={IsShiftDisabled || myself}
                    />
                    有排班需求
                  </div>
                  <div className={style.name_checkbox}>
                    <Checkbox
                      checked={CanSNS}
                      inputProps={{ "aria-label": "controlled" }}
                      onChange={handleCanSNSChange}
                      size="small"
                      disabled={CanSNSDisabled || myself}
                    />
                    可發送簡訊
                  </div>
                </FormGroup>
              </div>
            </div>
            <div className={style.seven_line}>
              <div className={style.identity_box}>
                <CssTextField
                  label="分機號碼"
                  variant="filled"
                  onChange={handleExtensionNumberChange}
                  value={ExtensionNumber}
                  style={{ width: "100%" }}
                  disabled={myself}
                />
              </div>
              <div className={style.identity_box}>
                <CssTextField
                  label="簡碼號碼"
                  variant="filled"
                  onChange={handleShortNumberChange}
                  value={ShortNumber}
                  style={{ width: "100%" }}
                  disabled={myself}
                />
              </div>
              <div className={style.identity_box}>
                <CssTextField
                  label="手機號碼"
                  variant="filled"
                  onChange={handlePhoneNumberChange}
                  onBlur={handlePhoneNumberBlur}
                  value={PhoneNumber}
                  style={{ width: "100%" }}
                  disabled={myself}
                  error={hasPhoneNumberError}
                />
                <div
                  style={{ color: "#EB4D3D", fontSize: "13px", padding: "4px" }}
                >
                  {hasPhoneNumberError && "手機號碼格式錯誤"}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default AccountAddBody;
